<template>
	<p class="text-white text-base"><slot></slot></p>
</template>
